export default {
  Get: {
    LIST_OF_CRITERIAS: 'getListOfCriterias',
    LIST_OF_PROPOSALS: 'getListOfProposals',
    CONFIG: 'getDemandConfigs'
  },
  Set: {
    ASSIGNVALUE: "setValue",
    MODAL_VISIBLE: "setModalVisible",
    DEMAND: 'setDemand',
    DEMANDORIGIN: 'setDemandOrigin',
    UPDATE_DEMANDORIGIN: 'updateDemandOrigin',
    DEMAND_INITIALIZED: 'setDemandInitialzed',
    DEMAND_FOR_CREATING: 'setDemandForCreating',
    NEW_DEMAND: 'insertDemand',
    UPDATE_DEMAND: 'updateDemand',
    DELETE_DEMAND: 'deleteDemand',
    LIST_OF_CRITERIAS: 'setListOfCriterias',
    LIST_OF_PROPOSALS: 'setListOfProposals',
    CONFIG: 'setDemandConfigs',
    SET_IS_SAVING: 'setIsSaving'
  }
}